export default __webpack_public_path__ + "static/media/clock-time-16px.af68a351.svg";